import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

const TEST_ID = 'num-lock-icon';

/**
 * An Icon whose SVG shows a lock with a 1 on it
 * @param IconProps
 */
export const NumLockIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];
    return (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 18 20"
            className={fillStyles}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9 0C12.3137 0 15 2.68629 15 6V7.15039C15.2826 7.21232 15.5543 7.302 15.8164 7.43555C16.5689 7.81902 17.181 8.43111 17.5645 9.18359C17.8117 9.66896 17.9102 10.186 17.9561 10.748C18.0003 11.2892 18 11.9538 18 12.7588V14.2412C18 15.0462 18.0003 15.7108 17.9561 16.252C17.9102 16.814 17.8117 17.331 17.5645 17.8164C17.181 18.5689 16.5689 19.181 15.8164 19.5645C15.331 19.8117 14.814 19.9102 14.252 19.9561C13.7108 20.0003 13.0462 20 12.2412 20H5.75879C4.95381 20 4.28925 20.0003 3.74805 19.9561C3.18599 19.9102 2.6689 19.8117 2.18359 19.5645C1.43107 19.181 0.819013 18.5689 0.435547 17.8164C0.188267 17.331 0.0898705 16.814 0.0439459 16.252C-0.000274134 15.7108 -9.44637e-06 15.0462 5.53629e-07 14.2412V12.7588C-9.44637e-06 11.9538 -0.000274134 11.2892 0.0439459 10.748C0.0898705 10.186 0.188267 9.66896 0.435547 9.18359C0.819012 8.43112 1.43108 7.81902 2.18359 7.43555C2.44569 7.302 2.7174 7.21233 3 7.15039V6C3 2.68629 5.68629 2.99214e-07 9 0ZM9.52539 9.2002C9.17224 9.20022 8.89877 9.25195 8.5 9.52539L6.87012 10.6533C6.60255 10.8413 6.50005 11.0349 6.5 11.2969C6.5 11.6614 6.75618 11.9119 7.10352 11.9121C7.28006 11.9121 7.40016 11.8726 7.55957 11.7588L8.76172 10.9209H8.7959V16.8066C8.7959 17.3252 9.14425 17.667 9.65137 17.667C10.1583 17.6668 10.5 17.325 10.5 16.8066V10.1631C10.5 9.57054 10.1351 9.2002 9.52539 9.2002ZM9 2C6.79086 2 5 3.79086 5 6V7.00195H13V6C13 3.79086 11.2091 2 9 2Z" />
        </svg>
    );
};

NumLockIcon.TEST_ID = TEST_ID;
